import BaseApi from './base.api'

class RegistryApi extends BaseApi {
  branchesUrl = 'branches/'
  buyerTypesUrl = 'buyer-types/'
  channelsUrl = 'channels/'
  channelTypesUrl = 'channel-types/'
  companyUrl = 'company-data/'
  customerContactsUrl = 'customer-contacts/'
  customerElectronicInvoiceAgreementTypesUrl = 'customer-electronic-invoice-agreement-types/'
  customerElectronicInvoiceUrl = 'customer-electronic-invoice/'
  customerPrivacyModuleFieldsUrl = 'customer-privacy-module-fields/'
  customerPrivacyModulesUrl = 'customer-privacy-modules/'
  customersSearchUrl = 'customers/search/'
  customersUrl = 'customers/'
  customerTypesUrl = 'customer-types/'
  depositsUrl = 'deposits/'
  discountCategoriesUrl = 'discount-categories/'
  discountCategoryAccountingsUrl = 'discount-category-accountings/'
  discountListsUrl = 'discount-lists/'
  documentSeriesUrl = 'document-series/'
  documentSeriesRulesUrl = 'document-series-rules/'
  externalPrivacyDataProcessorsUrl = 'external-privacy-data-processors/'
  identityDocumentAuthoritiesUrl = 'identity-authorities/'
  identityDocumentTypesUrl = 'identity-document-types/'
  infoBikeUrl = 'infobike/'
  jobTypesUrl = 'job-types/'
  packagingTypesUrl = 'packaging-types/'
  productFamiliesUrl = 'product-families/'
  productsSearchUrl = 'products/search/'
  productSupersessionUrl = (productId) => `${this.productsUrl}${productId}/supersessions/`
  productsUrl = 'products/'
  productAccountingsUrl = 'product-accountings/'
  productDocumentsUrl = 'product-documents/'
  productWeightsUrl = 'product-weights/'
  serviceAttachmentsUrl = 'service-attachments/'
  subjectContactsUrl = 'subject-contacts/'
  subjectContactsSearchUrl = 'subject-contacts/search/'
  subjectDiscountsUrl = 'subject-discounts/'
  subjectDocumentsUrl = 'subject-documents/'
  subjectProfilesUrl = 'subject-profiles/'
  subjectsUrl = 'subjects/'
  subjectTypesUrl = 'subject-types/'
  supplierBrandsUrl = 'supplier-brands/'
  supplierBrandTransmissionsUrl = 'supplier-brand-transmissions/'
  supplierContactsUrl = 'supplier-contacts/'
  supplierDivisionsUrl = 'supplier-divisions/'
  supplierDivisionTypesUrl = 'supplier-division-types/'
  supplierOrderTypesUrl = 'supplier-order-types/'
  suppliersUrl = 'suppliers/'
  supplierTypesUrl = 'supplier-types/'
  vehiclesUrl = 'vehicles/'
  vehiclesSearchUrl = 'vehicles/search/'
  vehicleInterventionsUrl = 'vehicle-interventions/'
  vehicleMovementsUrl = 'vehicle-movements/'
  vehiclePlatesUrl = 'vehicle-plates/'
  vehicleTypesUrl = 'vehicle-types/'

  constructor() {
    super('registry/')
  }

  getCompanyDataAsync = (params) => this.get(this.companyUrl, params)
  getCompanyAddressAsync = (address, params) => this.get(`address/${address}/`, params)
  updateCompanyDataAsync = (data) => this.patch(`${this.companyUrl}${data.id}/`, data)
  updateCompanyLogoAsync = (id, file) => {
    const formData = new FormData()
    formData.append('logo_file', file)
    return this.patch(`${this.companyUrl}${id}/`, formData)
  }

  getCustomersAsync = (params) => this.get(this.customersUrl, params)
  getCustomerPrivacyModuleFieldsAsync = (params) => this.get(this.customerPrivacyModuleFieldsUrl, params)
  isCustomerLockedAsync = (customerId) => this.get(`${this.customersUrl}${customerId}/locked-by`)
  downloadCustomerVatFileAsync = (vatFileId, fileName) => this.download(`${this.customersUrl}vat-files/${vatFileId}`, fileName)
  createSubjectAsync = (data) => this.post(this.subjectsUrl, data)
  createSubjectContactAsync = (data) => this.post(this.subjectContactsUrl, data)

  getBranchesAsync = (params) => this.get(this.branchesUrl, params)
  getBuyerTypesAsync = (params) => this.get(this.buyerTypesUrl, params)
  getChannelsAsync = (params) => this.get(this.channelsUrl, params)
  getChannelTypesAsync = (params) => this.get(this.channelTypesUrl, params)
  getCustomerElectronicInvoiceAgreementTypesAsync = (params) => this.get(this.customerElectronicInvoiceAgreementTypesUrl, params)
  getCustomerTypesAsync = (params) => this.get(this.customerTypesUrl, params)
  getDepositsAsync = (params) => this.get(this.depositsUrl, params)
  getDiscountCategoriesAsync = (params) => this.get(this.discountCategoriesUrl, params)
  createDiscountCategoryAsync = (data) => this.post(this.discountCategoriesUrl, data)
  getDiscountCategoryAccountingsAsync = (params) => this.get(this.discountCategoryAccountingsUrl, params)
  getDiscountListsAsync = (params) => this.get(this.discountListsUrl, params)
  getDocumentSeriesAsync = (params) => this.get(this.documentSeriesUrl, params)
  getDocumentSeriesRulesAsync = (params) => this.get(this.documentSeriesRulesUrl, params)
  getExternalPrivacyDataProcessorsAsync = (params) => this.get(this.externalPrivacyDataProcessorsUrl, params)
  getIdentityDocumentAuthoritiesAsync = (params) => this.get(this.identityDocumentAuthoritiesUrl, params)
  getIdentityDocumentTypesAsync = (params) => this.get(this.identityDocumentTypesUrl, params)
  getJobTypesAsync = (params) => this.get(this.jobTypesUrl, params)
  getPackagingTypesAsync = (params) => this.get(this.packagingTypesUrl, params)
  getProductAccountingsAsync = (params) => this.get(this.productAccountingsUrl, params)
  getProductByIdAsync = (id, params) => this.get(this.productsUrl, { id: id, ...params })
  getProductAsync = (params) => this.get(this.productsUrl, params)
  getProductDetailsAsync = (id, params) => this.get(`${this.productsUrl}${id}/details`, params)
  getProductFamiliesAsync = (params) => this.get(this.productFamiliesUrl, params)
  getSubjectContactNextIdAsync = () => this.get(`${this.subjectContactsUrl}next/`)
  getSubjectDetailsAsync = (id, params) => this.get(`${this.subjectsUrl}${id}/details`, params)
  getSubjectNextIdAsync = () => this.get(`${this.subjectsUrl}next/`)
  getSubjectTypesAsync = (params) => this.get(this.subjectTypesUrl, params)
  getSupplierDivisionsAsync = (params) => this.get(this.supplierDivisionsUrl, params)
  getSupplierDivisionTypesAsync = (params) => this.get(this.supplierDivisionTypesUrl, params)
  getSupplierOrderTypesAsync = (params) => this.get(this.supplierOrderTypesUrl, params)
  getSuppliersAsync = (params) => this.get(this.suppliersUrl, params)
  getSupplierTypesAsync = (params) => this.get(this.supplierTypesUrl, params)
  getSupplierDivisionNextIdAsync = () => this.get(`${this.supplierDivisionsUrl}next/`)

  deleteProductByIdAsync = (id, config) => this.delete(`${this.productsUrl}${id}`, config)
  createProductAsync = (data) => this.post(this.productsUrl, data)
  updateProductAsync = (id, data) => this.patch(`${this.productsUrl}${id}`, data)

  getSupplierBrandsAsync = (params) => this.get(this.supplierBrandsUrl, params)
  createSupplierBrandAsync = (data) => this.post(this.supplierBrandsUrl, data)
  mergeSupplierBrandsAsync = (data) => this.post(`${this.supplierBrandsUrl}merge-supplier-brands/`, data)
  getSubjectContactsAsync = (params) => this.get(this.subjectContactsUrl, params)
  getSubjectDiscountsAsync = (params) => this.get(this.subjectDiscountsUrl, params)
  createSubjectDiscountAsync = (data) => this.post(this.subjectDiscountsUrl, data)

  getVehiclesAsync = (vehicleId, params) => this.get(`${this.vehiclesUrl}${vehicleId || ''}`, params)
  getInfoBikeBrandsAsync = (params) => this.get(`${this.infoBikeUrl}brands/`, params)
  getInfoBikeModelsAsync = (params) => this.get(`${this.infoBikeUrl}models/`, params)
  getInfoBikeVariantsAsync = (params) => this.get(`${this.infoBikeUrl}variants/`, params)
  getInfoBikeDataByInfoBikeCodeAsync = (params) => this.get(`${this.infoBikeUrl}data-by-infoBikeCode/`, params)
  getVehicleMovementsNextIdAsync = () => this.get(this.vehicleMovementsUrl)
  getVehicleNextIdAsync = (params) => this.get(`${this.vehiclesUrl}next/`, params)
  getVehiclePlatesAsync = (params) => this.get(this.vehiclePlatesUrl, params)
  getVehicleTypesAsync = (params) => this.get(this.vehicleTypesUrl, params)
  createVehicleAsync = (data) => this.post(this.vehiclesUrl, data)
  createVehicleMovementAsync = (data) => this.post(this.vehicleMovementsUrl, data)

  createDocumentSeriesRuleAsync = (data) => this.post(this.documentSeriesRulesUrl, data)

  updateCustomerPrivacyModuleAsync = (id, data) => this.patch(`${this.customerPrivacyModulesUrl}${id}/`, data)
  updateSubjectAsync = (id, data) => this.patch(`${this.subjectsUrl}${id}/`, data)

  getVehicleNextCarServiceAsync = (vehicleId) => this.get(`${this.vehiclesUrl}next-filtered/`, { vehicle: vehicleId })
  getInfoBikeSearchAsync = (plate_number) => this.get(`${this.vehiclesUrl}infoBike-search/`, { plate: plate_number })

  printPrivacyAsync = (filename, data, config) => this.download(`${this.customersUrl}print/`, filename, null, false, { ...config, method: 'post', data: data })
  checkCustomerPrivacyAsync = (customerId) => this.post(`${this.customersUrl}check-customer-privacy/`, { customer_id: customerId })

  getAttachmentAsync = (params) => this.get(this.serviceAttachmentsUrl, params)
  getAttachmentChartDataAsync = (params) => this.get(`${this.serviceAttachmentsUrl}chart-data/`, params)
  batchDeleteServiceAttachmentsAsync = (ids) => this.post(`${this.serviceAttachmentsUrl}batch-delete/`, { ids })
  previewAttachmentByIdAsync = (id) => this.downloadBlob(`${this.serviceAttachmentsUrl}${id}/download/`, null, false, { method: 'post' })
  uploadServiceAttachmentAsync = (data, file, config = {}) => {
    const formData = new FormData()
    Object.entries(data).forEach(([key, value]) => { if (value != null) formData.append(key, value) })
    formData.append('attachment_file', file)
    return this.post(`${this.serviceAttachmentsUrl}upload-attachment/`, formData, config)
  }
}

export const registryApi = new RegistryApi()
